import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapsService } from './maps.service';

@NgModule({
  imports: [CommonModule],
})
export class IriroFrontendLibsUtilMapsModule {
  static forRoot(config: { googleMapsKey: string }): ModuleWithProviders<IriroFrontendLibsUtilMapsModule> {
    MapsService.googleApiKey = config.googleMapsKey;

    return {
      ngModule: IriroFrontendLibsUtilMapsModule,
      providers: [],
    };
  }
}
